const actions = {
    IMPORT_CREATE_TRANSACTIONS_REQUEST: 'IMPORT_CREATE_TRANSACTIONS_REQUEST',
    IMPORT_CREATE_TRANSACTIONS_SUCCESS: 'IMPORT_CREATE_TRANSACTIONS_SUCCESS',
    IMPORT_CREATE_TRANSACTIONS_ERROR: 'IMPORT_CREATE_TRANSACTIONS_ERROR',
    IMPORT_RESET_STATE: 'IMPORT_RESET_STATE',

    createTransactions: request => ({
        type: actions.IMPORT_CREATE_TRANSACTIONS_REQUEST,
        request,
    }),
    resetState: () => ({
        type: actions.IMPORT_RESET_STATE,
    }),
};
export default actions;
